export default __webpack_public_path__ + "static/media/654.f1e9755a.png";